import React, { Component } from "react";
import Lottie from "react-lottie";
import LoadingData from "../../../../app/assets/animations/CFASpinner.json";

class CFASpinner extends Component {
  render() {
    const defaultOptions = {
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: LoadingData,
    };

    return (
      <div
        className="bounceIn"
        style={{
          width: "70px",
          margin: "auto",
        }}
      >
        <Lottie options={defaultOptions} />
      </div>
    );
  }
}
export default CFASpinner;
